module.exports = __webpack_public_path__ + "img/Endesa_120X35.48b5113f.png";